import React, { createContext, Dispatch, SetStateAction, useEffect, useState } from "react";
import { IPet } from "../Pages/Pets/Pets";

type PetsContextState = {
	value: IPet[],
	setState: Dispatch<SetStateAction<PetsContextState>>;
}

const createInitialPetsCtxValue = (value) => {
    return {
        state: { value: value },
        setState: (state: PetsContextState): void => {console.log(state);},
    };
};

const { Provider, Consumer } = createContext(createInitialPetsCtxValue([]));

export const PetsProvider = (props: {children: any, value: any}) => {
    const [state, setState] = useState(createInitialPetsCtxValue(props.value).state);
    useEffect(() => {
        setState(createInitialPetsCtxValue(props.value).state);
        const info = createInitialPetsCtxValue(props.value).state;
    }, [props.value]);

    return (
        <Provider value={{ state, setState }}>
            {props.children}
        </Provider>
    );
};

export {Consumer as PetsConsumer};
